'use client'

import { useState } from 'react'
import { useSession } from 'next-auth/react'

// Exit "View as user". Clears the JWT impersonate directive (via NextAuth's
// signed session update) AND audits the stop, then hard-navigates so every
// cached RSC payload is refetched as the real admin. Ordering: audit first
// (the /stop route is write-block-exempt), then clear the token.
export default function ExitImpersonationButton() {
  const { update } = useSession()
  const [busy, setBusy] = useState(false)

  async function exit() {
    if (busy) return
    setBusy(true)
    try {
      await fetch('/api/admin/impersonate/stop', { method: 'POST', cache: 'no-store' }).catch(
        () => {},
      )
      await update({ impersonate: null })
    } finally {
      // Full reload back to admin — avoids any client cache still holding the
      // impersonated identity.
      window.location.href = '/admin/users'
    }
  }

  return (
    <button
      type="button"
      onClick={exit}
      disabled={busy}
      className="rounded-md bg-white/20 px-3 py-1 text-sm font-semibold text-white hover:bg-white/30 disabled:opacity-60"
    >
      {busy ? 'Exiting…' : 'Exit'}
    </button>
  )
}
